module.exports = __webpack_public_path__ + "static/media/01C.aeeeee41.png";